<h1 class="visually-hidden">{{ 'accounting.accounting' | transloco }}</h1>
@if (!loading) {
  <div class="padding">
    <mat-card>
      <mat-card-content>
        <div class="table-container">
          <mat-tab-group animationDuration="0ms" [selectedIndex]="selectedIndex">
            <mat-tab [label]="'accounting.servicePricing' | transloco">
              <app-service-pricing></app-service-pricing>
            </mat-tab>
            <mat-tab [label]="'accounting.disbursementPricing' | transloco">
              <app-disbursement-pricing></app-disbursement-pricing>
            </mat-tab>
            @if (hasAccountingAccess) {
              <mat-tab [label]="'common.labels.invoices' | transloco">
                <app-invoices></app-invoices>
              </mat-tab>
            }
          </mat-tab-group>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}